<template>
    <div class="card height-500 p-5">
        <h1 class="text-center">Under construction</h1>
        <img class="header-navbar img-fluid responsive" src="/app-assets/images/construction.svg" alt="">
    </div>
</template>